module.exports = __webpack_public_path__ + "static/media/next.8426d448.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/next.svg
// module id = 74
// module chunks = 1